import { render, staticRenderFns } from "./OrderRefund.vue?vue&type=template&id=7387362c&scoped=true"
import script from "./OrderRefund.vue?vue&type=script&lang=js"
export * from "./OrderRefund.vue?vue&type=script&lang=js"
import style0 from "./OrderRefund.vue?vue&type=style&index=0&id=7387362c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7387362c",
  null
  
)

export default component.exports